import { render, staticRenderFns } from "./AddGenealogy.vue?vue&type=template&id=3a96273d&scoped=true"
import script from "./AddGenealogy.vue?vue&type=script&lang=js"
export * from "./AddGenealogy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96273d",
  null
  
)

export default component.exports